import Tables from 'src/class/Tables';
import i18n from 'src/i18n';

const configTable = (data, onlyScheduled, onlyExecuted) => {
  const Table = { ...Tables.Table };

  Table.tableColumns = [
    {
      prop: 'activity',
      label: i18n.t('common_words.activity'),
      minWidth: 250,
      align: 'left',
      sortable: true,
      fixed: true,
    },
    {
      prop: 'lots',
      label: i18n.t('common_words.allotment(s)'),
      minWidth: 100,
      align: 'left',
      sortable: true,
      fixed: true,
      formatter: (row) =>
        Array.isArray(row.lots) ? row.lots.join(', ') : row.lots,
    },
  ];

  if (data && data.weeks) {
    Table.tableColumns.push(
      ...data.weeks.map((week) => {
        const showAll = !onlyScheduled && !onlyExecuted;

        return {
          label: `${week}`,
          align: 'center',
          children: [
            {
              prop: `weeks.${week}.planned_quantity`,
              label: 'P',
              minWidth: 60,
              align: 'center',
              show: showAll || onlyScheduled,
            },
            {
              prop: `weeks.${week}.executed_quantity`,
              label: 'E',
              minWidth: 60,
              align: 'center',
              show: showAll || onlyExecuted,
            },
            {
              prop: `weeks.${week}.completion_rate`,
              label: '%',
              minWidth: 80,
              align: 'center',
              show: showAll,
            },
          ],
        };
      })
    );
  }

  return { Table };
};

export default configTable;
